// Port of api/fuel/app/classes/filter/search/games/filters/query/play/plays/count.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'play.plays.count',
	priority: 50,
	require: function(config, filter) {
		return (filter.threshold && filter.threshold.plays) || rangeActive(filter.plays, 0, 100)
	},
	run: function(config, filter, data, query) {
		if (filter.threshold && filter.threshold.plays) {
			query.having('SUM(p.play_count)', '>=', filter.threshold.plays)
		}

		if (filter.plays.from > 0) {
			query.having('SUM(p.play_count)', '>=', filter.plays.from)
		}

		if (filter.plays.to < 100) {
			if (filter.plays.from > 0) {
				query.having('SUM(p.play_count)', '<=', filter.plays.to)
			} else {
				query.having('COALESCE(SUM(p.play_count), 0)', '<=', filter.plays.to)
				query.where('p.user_id', 'in', data.users)
				query.join('play', 'p', 'LEFT JOIN')
				query.leftjoin('p', true)
			}
		}
	}
}
